import { EGSGame } from '@/entities/platforms/egs/types/types'
import { SteamUserDataType } from '@/entities/user'
import { useStyles } from './style'
import { Spiner } from '@/shared/ui/spiner'
import { $userLanguage } from '@/entities/user'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
import { Icon } from '@/shared/ui/icon'

export const GamesList = (props: Pick<SteamUserDataType, 'gamesList'>) => {
  const { gamesList } = props
  const { classes } = useStyles({})
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.profile.gameList

  if (!gamesList) {
    return <Spiner size="m" />
  }
  gamesList.sort((a, b) => b.total_hours - a.total_hours)
  return (
    <div className={classes.root}>
      {gamesList.map((game) => (
        <div
          className={classes.listItem}
          key={game.id}
        >
          <div className={classes.gameInfo}>
            <div className={classes.gameIcon}>
              <img
                crossOrigin="anonymous"
                src={game.img_url}
                alt={game.name}
              />
            </div>
            <div className={classes.gameTitleAndHoursWrapper}>
              <span className={classes.gameTitle}>{game.name}</span>
              <div>
                <Icon
                  view="time"
                  width={12}
                  style={{ position: 'relative', top: '1px', marginRight: '2px' }}
                />
                <span className={classes.hours}>
                  {game.total_hours} {`${texts.unit.toLowerCase()}`}
                </span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
export const EGSGamesList = ({ gamesList }: { gamesList: EGSGame[] }) => {
  const { classes } = useStyles({})

  if (!gamesList.length) return null
  return (
    <div className={classes.root}>
      {gamesList.map((game) => (
        <div
          className={classes.listItem}
          key={game.name}
        >
          <div className={classes.gameInfo}>
            <div className={classes.gameIcon}>
              <img
                crossOrigin="anonymous"
                src={game.img_url}
                alt={game.name}
              />
            </div>
            <div className={classes.gameTitleAndHoursWrapper}>
              <span className={classes.gameTitle}>{game.name}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
